"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradMeterHelpMultiRate = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var IconStyled_1 = require("../../../../../components/IconStyled");
var copy_1 = require("../../../../../copy");
var MeterHelp_styled_1 = require("./MeterHelp.styled");
var TradMeterHelpMultiRate = function (_a) {
    var registerCount = _a.registerCount;
    var _b = (0, core_1.useComponents)(), Icon = _b.Icon, Ul = _b.Ul, Li = _b.Li, Heading4 = _b.Heading4;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (registerCount > 2) {
        return (react_1.default.createElement(MeterHelp_styled_1.StyledHelp, null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpMultiRateHeading" })),
            react_1.default.createElement(Copy, { copyKey: "tradMeterHelpMultiRateInfo" })));
    }
    return (react_1.default.createElement(MeterHelp_styled_1.StyledHelp, null,
        react_1.default.createElement("section", null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateHeading" })),
            react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                react_1.default.createElement(MeterHelp_styled_1.StyledMeterImageContainer, null,
                    react_1.default.createElement(MeterHelp_styled_1.StyledMultiRateMeter, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Ul, null,
                        react_1.default.createElement(Li, null,
                            react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateCorrectReading" }),
                            react_1.default.createElement(MeterHelp_styled_1.StyledMultiRateContainer, null,
                                react_1.default.createElement(MeterHelp_styled_1.StyledMultiRateRow, null,
                                    react_1.default.createElement(IconStyled_1.StyledIconWrapper, { inline: true },
                                        react_1.default.createElement(Icon, { name: "offpeakLegacy" })),
                                    react_1.default.createElement(MeterHelp_styled_1.StyledText, null,
                                        react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateOffPeakReadings" }))),
                                react_1.default.createElement(MeterHelp_styled_1.StyledMultiRateRow, null,
                                    react_1.default.createElement(IconStyled_1.StyledIconWrapper, { inline: true },
                                        react_1.default.createElement(Icon, { name: "peakLegacy" })),
                                    react_1.default.createElement(MeterHelp_styled_1.StyledText, null,
                                        react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRatePeakReadings" }))))),
                        react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateInfo" }))))),
        react_1.default.createElement("section", null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateSingleDisplayHeading" })),
            react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                react_1.default.createElement(MeterHelp_styled_1.StyledMeterImageContainer, null,
                    react_1.default.createElement(MeterHelp_styled_1.StyledMultiRateMeterAlt, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpTwinRateSingleDisplayInfo" }))))));
};
exports.TradMeterHelpMultiRate = TradMeterHelpMultiRate;
